<template>
    <div class="mb-2">
        <input type="button" @click=" adicionarEstilo" class="btn btn-success" value="Criar">
    </div>
</template>
<script>

export default {

    data: function () {
        return {
            VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
            loading: false,
            estilo: {
                id_vsl: '45',
                controls_bt_big_player: '1',
                controls_bt_small_player: '1',
                controls_progress_bar: '1',
                controls_video_time: '1',
                controls_video_vol: '1',
                controls_bt_screem: '1',
                controls_avan_10s: '1',
                controls_retro_10s: '1',
                controls_back_color: '#ff0000',
                controls_main_color: '#ff0000',
                errorMessage: null,
            }

        }
    },

    methods: {
        adicionarEstilo() {
            fetch(`${this.VUE_APP_HOST_API_BACKEND}/control`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: '{"id_vsl":"' + this.estilo.id_vsl +
                    '","controls_bt_big_player":"' + this.estilo.controls_bt_big_player +
                    '","controls_bt_small_player":"' + this.estilo.controls_bt_small_player +
                    '","controls_progress_bar":"' + this.estilo.controls_progress_bar +
                    '","controls_video_time":"' + this.estilo.controls_video_time +
                    '","controls_video_vol":"' + this.estilo.controls_video_vol +
                    '","controls_bt_screem":"' + this.estilo.controls_bt_screem +
                    '","controls_avan_10s":"' + this.estilo.controls_avan_10s +
                    '","controls_retro_10s":"' + this.estilo.controls_retro_10s +
                    '","controls_back_color":"' + this.estilo.controls_back_color +
                    '","controls_main_color":"' + this.estilo.controls_main_color +

                    '"}'
            })

                .then(response => {
                    this.$alert("adicionada com sucesso.")
                    return this.$router.push('');

                })
                .catch(err => console.error(err));
        },

    }
}


</script>
